interface MarkedDate {
  date: Date;
  color: string;
}

interface DateInputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "defaultValue"
  > {
  name: string;
  markedDates?: MarkedDate[];
  defaultValue?: Date;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DateInput({
  name,
  markedDates = [],
  defaultValue,
  onChange,
  ...props
}: DateInputProps) {
  return (
    <div>
      <input
        type="date"
        name={name}
        defaultValue={String(defaultValue?.toLocaleDateString()) || undefined}
        onChange={onChange}
        className="border-2 border-Grey2 p-2 rounded-md cursor-pointer w-full min-w-0 flex-1"
        style={{ cursor: "pointer" }}
        {...props}
      />
    </div>
  );
}
